/* eslint-disable prettier/prettier, linebreak-style, indent */

class RecruitmentHero {
  constructor() {
    this.selectors = {
      page: '.js-rec-page',
      hero: '.js-rec-hero',
      arrow: '.js-rec-hero-arrow',
      nav: '.js-rec-hero-nav',
      section: '.js-rec-section',
    };

    this.classes = {
      active: 'is-active',
      sticky: 'is-sticky',
      labelLeft: 'is-left',
      labelRight: 'is-right',
    };

    this.getDOM();
    this.scrollDown();
    this.navigation();
  }

  getDOM() {
    this.DOM = {
      page: document.querySelector(this.selectors.page),
      hero: document.querySelector(this.selectors.hero),
      arrow: document.querySelector(this.selectors.arrow),
      nav: document.querySelector(this.selectors.nav),
    };
  }

  scrollDown() {
    if (this.DOM.arrow) {
      this.DOM.arrow.addEventListener('click', () => {
        window.scroll({
          top: this.DOM.hero.clientHeight,
          left: 0,
          behavior: 'smooth',
        });
      });
    }
  }

  navigationSticky() {
    const navPos = this.DOM.nav.getBoundingClientRect();
    this.DOM.nav.classList.toggle(this.classes.sticky, navPos.top < 0);
  }

  navigation() {
    if (this.DOM.nav) {
      this.navigationSticky();

      window.addEventListener('scroll', () => {
        this.navigationSticky();
      });

      this.DOM.navLinks = this.DOM.nav.querySelectorAll('a');

      this.DOM.navLinks.forEach((link) => {
        link.addEventListener('mouseover', () => {
          const linkPos = link.getBoundingClientRect();
          const navPos = this.DOM.nav.getBoundingClientRect();
          const label = link.querySelector('span');

          if (linkPos.right + 60 > navPos.right) {
            label.classList.add(this.classes.labelRight);
          } else if (linkPos.left - 60 < navPos.left) {
            label.classList.add(this.classes.labelLeft);
          } else {
            label.classList.remove(
              this.classes.labelRight,
              this.classes.labelLeft,
            );
          }

          this.DOM.navLinks.forEach((l) => {
            l.blur();
          });
        });

        link.addEventListener('click', (e) => {
          e.preventDefault();
          const sectionId = link.getAttribute('href');
          const section = document.querySelector(
            `${this.selectors.section}${sectionId}`,
          );

          const activeLink = this.DOM.nav.querySelector(
            `.${this.classes.active}`,
          );

          if (activeLink) {
            activeLink.classList.remove(this.classes.active);
          }

          link.classList.add(this.classes.active);

          if (section) {
            const sectionPos = section.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const offsetTop =
              sectionPos.top +
              scrollTop -
              this.DOM.nav.querySelector('ul').clientHeight;

            window.scroll({
              top: offsetTop,
              left: 0,
              behavior: 'smooth',
            });
          }
        });
      });
    }
  }
}

export default new RecruitmentHero();
